import { preferenceKeyForUser } from 'common/constants/userPreferences';
import { User } from 'common/types/user';
import {
  getPreference,
  migrateLegacyLocalStorageKey,
  migrateLegacyMultiUserPreference,
  setPreference,
} from 'services/storage/preferencesIndexedDB';

export const getUserPreferences = (user: User, item: string | null) => {
  if (!item || !user) return null;

  try {
    const preferences = JSON.parse(item);
    const userId = user.id as number;
    return preferences?.[userId] ?? preferences?.[String(userId)] ?? null;
  } catch {
    return null;
  }
};

export async function getUserPreferenceValue<T>(
  user: User | { id?: string | number } | null | undefined,
  legacyKey: string
): Promise<T | null> {
  if (user?.id === undefined || user?.id === null) return null;
  const userId = Number(user.id);
  if (Number.isNaN(userId)) return null;
  const perUserKey = preferenceKeyForUser(legacyKey, userId);
  await migrateLegacyMultiUserPreference(legacyKey, perUserKey, userId);
  await migrateLegacyLocalStorageKey(perUserKey);
  const value = await getPreference<T>(perUserKey);
  return value ?? null;
}

export async function setUserPreferenceValue(
  user: User | { id?: string | number } | null | undefined,
  legacyKey: string,
  value: unknown
): Promise<void> {
  if (user?.id === undefined || user?.id === null) return;
  const userId = Number(user.id);
  if (Number.isNaN(userId)) return;
  const perUserKey = preferenceKeyForUser(legacyKey, userId);
  await setPreference(perUserKey, value);
}

/** @deprecated Use setUserPreferenceValue — kept for legacy sync call sites during migration */
export const setUserPreferences = (user: User, key: string, value: unknown) => {
  if (!user || !key) return;
  setUserPreferenceValue(user, key, value);
};
